import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class InputTextarea extends Vue {
  @Prop({ required: true }) public name?: string;
  @Prop() public label?: string;
  @Prop() public placeholder?: string;
  @Prop({ default: false }) public required?: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ default: false }) public readonly?: boolean;
  @Prop() public value?: string;
  @Prop({ required: true }) public maxlength!: number;
  protected randomId: string = Math.floor(Math.random() * Math.floor(100000000)).toString();
}
